import React, { useState, useEffect } from "react";
import { toggleMenu } from "../../utils/helpers";
import PageTitle from "../../components/PageTitle";
import ConfirmationModal from "../../components/ConfirmationModal";

const CreateOffboardingRequest = ({ title }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    leavingComment: "",
    experienceComment: "",
    feedbackComment: "",
  });

  const reset = () => {
    setFormData({
      leavingComment: "",
      experienceComment: "",
      feedbackComment: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setIsLoading(true);
    setTimeout(() => {
      console.log("Form Submitted:", formData);
      setIsLoading(false);
      setShowConfirm(false);
      reset();
    }, 1500);
  };

  const renderCharacterBadge = (field, max) => (
    <div className="badge badge-danger">
      Character Limit: {formData[field].length}/{max}
    </div>
  );

  useEffect(() => {
    if (showConfirm) {
      const myModal = new window.bootstrap.Modal(
        document.getElementById("submitConfirmModal")
      );
      myModal.show();
    }
  }, [showConfirm]);
  return (
    <div className="wrapper-body">
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} />
      </div>

      <div className="card">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (!e.target.checkValidity()) {
              e.target.reportValidity();
              return;
            }
            setShowConfirm(true);
          }}
          className="d-f flex-column inputs gap-15"
        >
          {/* Reason for Leaving */}
          <div className="d-f f-w inputs">
            <div className="input-group">
              <label htmlFor="reason" className="question">
                1. Could you please share the primary reason for your decision
                to leave the company? *
              </label>
              <textarea
                name="leavingComment"
                id="reason"
                rows="6"
                placeholder="Type Here"
                maxLength="2000"
                value={formData.leavingComment}
                onChange={handleChange}
                required
                className="rounded-lg w-full p-2 border border-gray-300"
              ></textarea>
              {renderCharacterBadge("leavingComment", 2000)}
            </div>
          </div>
          {/* Overall Experience */}
          <div className="d-f f-w inputs">
            <div className="input-group">
              <label htmlFor="experience" className="question">
                2. How would you describe your overall experience working with
                us? *
              </label>
              <textarea
                name="experienceComment"
                id="experience"
                rows="6"
                placeholder="Type Here"
                maxLength="2000"
                value={formData.experienceComment}
                onChange={handleChange}
                required
                className="rounded-lg w-full p-2 border border-gray-300"
              ></textarea>
              {renderCharacterBadge("experienceComment", 2000)}
            </div>
          </div>
          {/* Feedback */}
          <div className="d-f f-w inputs">
            <div className="input-group">
              <label htmlFor="feedback" className="question">
                3. Do you have any thoughts or feedback you’d like to leave for
                the team or management? *
              </label>
              <textarea
                name="feedbackComment"
                id="feedback"
                rows="6"
                placeholder="Type Here"
                maxLength="5000"
                value={formData.feedbackComment}
                onChange={handleChange}
                required
                className="rounded-lg w-full p-2 border border-gray-300"
              ></textarea>
              {renderCharacterBadge("feedbackComment", 5000)}
            </div>
          </div>
          <div className="hr d-f gap-2">
            <button type="submit" className="theme-button mt-4">
              Submit
            </button>
            <button
              type="button"
              className="theme-button bg-grey mt-4"
              onClick={reset}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>

      <ConfirmationModal
        id="submitConfirmModal"
        text="Are you sure you want to submit this request?"
        onConfirm={handleSubmit}
        onCancel={() => setShowConfirm(false)}
        isLoading={isLoading}
      />
    </div>
  );
};

export default CreateOffboardingRequest;
